import {ngAsync} from 'shared/utils/ng-@decorators';
import type {State} from '../commons/constants/portaro.constants';
import {states} from '../commons/constants/portaro.constants';
import type {Logger, PortaroState} from 'typings/portaro.be.types';
import type LoggerDataService from './logger.data-service';
import type CurrentAuthService from '../commons/services/current-auth.service';

interface StateAwareLogger extends Logger {
    state: State;
}

export function decorateLoggersWithState(loggers: Logger[]): StateAwareLogger[] {
    return loggers.map((logger: StateAwareLogger) => {
        logger.state = states.NORMAL;
        return logger;
    });
}

export default class UtilController {
    public static readonly controllerName = 'UtilCtrl';

    public coverTransferSetting = {folder: null, filenamePattern: null};

    /*@ngInject*/
    constructor(public state: PortaroState,
                public loggers: StateAwareLogger[],
                private loggerDataService: LoggerDataService,
                public currentAuthService: CurrentAuthService) {
    }

    @ngAsync()
    public async saveLogger(logger: StateAwareLogger) {
        logger.state = states.PROCESSING;

        const savedLogger = await this.loggerDataService.changeLevel(logger.id, logger.level);

        logger.level = savedLogger.level;
        logger.state = states.NORMAL;
    }
}